const getters = {
    token: state => state.account.token,
    user_id: state => state.account.id,
    name: state => state.account.name,
    email: state => state.account.email,
    navigations: state => state.account.navigations,
    entities: state => state.account.entities,
    districtEntities: state => state.account.entities.districts || [],
    transporterEntities: state => state.account.entities.transporters || [],
    schoolEntities: state => state.account.entities.schools || [],
    role: state => state.account.role,
    roleAccessTypes: state => state.account.role.role_access.types || [],
    roleAccessRoles: state => state.account.role.role_access.roles || [],
    from: state => state.router.from,
    devices: state => state.common.devices,
    externalDevices: state => state.common.externalDevices,
    regions: state => state.common.regions,
    cardTypes: state => state.common.cardTypes,

    latitude: state => state.settings.latitude,
    longitude: state => state.settings.longitude,
    timezone: state => state.settings.timezone,
    
    country: state => state.settings.country,
}
export default getters